import { IinitialState } from '.';
import * as types from '../actions/actionTypes';
import { IfacilityContact } from '../models';

interface ContactsState {
    [key: string]: IfacilityContact[];
}

/**
 * Reducer for managing facility contacts by facility ID
 * IMPORTANT: All state updates must be immutable to ensure React re-renders properly
 * - Use filter() instead of splice() for deletions
 * - Use map() instead of direct array assignment for updates
 * - Always return new state objects, never mutate existing ones
 */
export default function contactsByFacilityReducer(state: ContactsState = {}, action: any): ContactsState {
    switch (action.type) {
        case types.SET_CONTACT_FOR_FACILITY:
            return { ...state, [action.id]: action.payload.data };
        case types.ADD_FACILITY_CONTACT: {
            const facilityContacts = state[action.payload.facilityID] || [];
            return { ...state, [action.payload.facilityID]: [...facilityContacts, action.payload] };
        }
        case types.UPDATE_FACILITY_CONTACT: {
            const facilityContacts = state[action.payload.facilityID];
            if (!facilityContacts) return state;
            // Create a new array with the updated contact to maintain immutability
            const updatedContacts = facilityContacts.map(fc => (fc.id === action.payload.id ? action.payload : fc));
            return { ...state, [action.payload.facilityID]: updatedContacts };
        }
        case types.DELETE_FACILITY_CONTACT: {
            const facilityContacts = state[action.payload.facilityID];
            if (!facilityContacts) return state;
            // Create a new array without the deleted contact to maintain immutability
            const updatedContacts = facilityContacts.filter(fc => fc.id !== action.payload.facilityContactID);
            return { ...state, [action.payload.facilityID]: updatedContacts };
        }
        default:
            return state;
    }
}
export const getContacts = (state: IinitialState) => state.contactsByFacility;
